import { EntityIndex, EntityID, World } from "@latticexyz/recs";
import { ActionSystem } from "@latticexyz/std-client";
import { NetworkLayer } from "../../Network";

export function charge(
  context: {
    network: NetworkLayer;
    actions: ActionSystem;
    world: World;
  },
  charger: EntityIndex,
  chargee: EntityIndex
) {
  const {
    network: { api: networkApi },
    world,
    actions,
  } = context;

  const actionID = `charge ${Date.now()}` as EntityID; // Date.now to have the actions ordered in the component browser

  actions.add({
    id: actionID,
    components: {},
    on: charger,
    requirement: () => true,
    updates: () => [],
    execute: async () => {
      return networkApi.charge(world.entities[charger], world.entities[chargee]);
    },
  });
}
